var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaaard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "caaard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7419",
    "data-name": "Rectangle 7419",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17796",
    "data-name": "Group 17796",
    transform: "translate(-8110.426 18179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17795",
    "data-name": "Group 17795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-svgrepo-com",
    transform: "translate(8109 -18179.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11065",
    "data-name": "Path 11065",
    d: "M14.8,3.92H5.2c-1.767,0-3.2,1.791-3.2,4v10c0,2.209,1.433,4,3.2,4h9.6c1.767,0,3.2-1.791,3.2-4v-10C18,5.711,16.567,3.92,14.8,3.92Z",
    transform: "translate(3.426)",
    fill: "none",
    stroke: "#02466a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11066",
    "data-name": "Path 11066",
    d: "M6.5,7.471,8.307,4.455l3.881,7.277H2L5.4,5.426Zm.543.981,1.26,2.31h2.27L8.257,6.424Zm-3.416,2.31H7.168L5.4,7.472ZM3.7,5.426A1.213,1.213,0,1,1,4.911,4.213,1.213,1.213,0,0,1,3.7,5.426Z",
    transform: "translate(8115.333 -18174.365)",
    fill: "#02466a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaaard);
export default __webpack_public_path__ + "static/media/caaard.a67ccf1b417da13707b006cf65f855ee.svg";
export { ForwardRef as ReactComponent };